export default __webpack_public_path__ + "static/media/Nunito-Light.c77d98f5.svg";